import React from 'react'
import { compose, lifecycle } from 'recompose'
import settings from '../settings'
import tracker from '../../../utils/tracker'
import FullSelection from './FullSelection'
import PreSelection from './PreSelection'
import { isDesigner } from '../../../utils/initValues'

const StoreSelection = ({
  storeId,
  store,
  checked,
  stores,
  loading,
  error,
  onChange,
  fallbackAddress,
  selectedAddress,
  selectedCity,
  selectedStore,
  selectedStoreUnavailable,
  customerAddress,
  storeIsPreSelectable,
  flow,
}) =>
  storeId && storeIsPreSelectable ? (
    <PreSelection
      store={store}
      checked={checked}
      onChange={onChange}
      flow={flow}
    />
  ) : (
    <FullSelection
      stores={stores}
      loading={loading}
      error={error}
      onChange={onChange}
      fallbackAddress={fallbackAddress}
      selectedAddress={selectedAddress}
      selectedCity={selectedCity}
      selectedStore={selectedStore}
      selectedStoreUnavailable={selectedStoreUnavailable}
      customerAddress={customerAddress}
    />
  )

const enhance = compose(
  lifecycle({
    componentDidUpdate(oldProps) {
      if (this.props.store && !oldProps.store) {
        const isSelectable =
          settings.excludedStudioTypes.indexOf(this.props.store.storeType) ===
            -1 && !this.props.store.hideInBada
        const extra = { flow: this.props.flow }
        if (isSelectable) {
          tracker.trackAuto(
            'BADA 2.0 pick a store',
            `${this.props.store.name} - ${this.props.store.id} - ${this.props.store.distanceInKilometers}km`,
            extra
          )

          this.props.onChange({
            selectedStore: this.props.store,
            preselected: true,
          })
        } else {
          this.props.onChange({
            selectedStore: null,
            preselected: false,
          })
        }
      }
      const isUnavailable =
        !isDesigner &&
        this.props.flow !== 'followup' &&
        (this.props.stores?.find((s) => +s.id === +this.props.selectedStore?.id)
          ?.hideOnAvailability ||
          false)
      if (
        isUnavailable &&
        (!this.props.selectedStoreUnavailable || this.props.selectedStore)
      ) {
        this.props.onChange({
          selectedStore: null,
          preselected: false,
          selectedStoreUnavailable: true,
        })
      } else if (
        !isUnavailable &&
        this.props.selectedStore &&
        this.props.selectedStoreUnavailable
      ) {
        this.props.onChange({
          selectedStoreUnavailable: false,
        })
      }
    },
  })
)

export default enhance(StoreSelection)
